const paginationD = {
  perPage: 10,
  currentPage: 1,
  total: 0,
  perPageOptions: [5, 10, 20, 25, 50],
};

const functions = {
  pagedDataD() {
    return this.reports['report2'].data.slice(this.fromD, this.toD);
  },
  pagedRowsD() {
    return this.reports['report2'].rows.slice(this.fromD, this.toD);
  },
  queriedDataD() {
    let result = this.reports['report2'].data;

    if (this.searchQueryD !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }

    this.paginationD.total = result.length;

    return result.slice(this.from, this.to);
  },
  toD() {
    let highBound = this.fromD + this.paginationD.perPage;
    if (this.total < highBound) {
      highBound = this.totalD;
    }
    return highBound;
  },
  fromD() {
    return this.paginationD.perPage * (this.paginationD.currentPage - 1);
  },
  totalD() {
    this.paginationD.total = this.reports['report2'].rows.length;

    return this.reports['report2'].rows.length;
  },
};

export default { paginationD, functions };
